<template>
  <div>
    <div class="is-mobile customSkele white-background" style="margin-bottom: 5px;">
      <div class="skele" style="padding-top: 10px;">
        <b-skeleton width="20%" :animated="true"></b-skeleton>
        <b-skeleton width="50%" :animated="true"></b-skeleton>
        <b-skeleton width="80%" :animated="true"></b-skeleton>
        <b-skeleton :animated="true"></b-skeleton>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ResultSkele',
  }
</script>

<style scoped>
  .skele {
    padding-right: 2rem;
    padding-left: 2rem;
  }
  .customSkele {
    border-style: solid;
    border-width: 1px;
    border-color: #E4E8E8;
    border-radius: 5px;
    width: 100%;
    height: 131px;
    color: #6b6565;
  }
  div.white-background {
    background-color: white;
  }
</style>
